export enum TournamentDetailsTab {
  TournamentOverview = 'overview',
  TournamentBracket = 'bracket',
  TournamentMyTeam = 'my-team',
  TournamentTeams = 'teams',
  TournamentPrizes = 'prizes',
  TournamentAdmin = 'admin',
}
